// Client-side mirror of backend `shared.predictions_engine._climate_zone`.
// Kept tiny + dependency-free so it can be imported by any list/card view.

const ZONE_STYLES = {
  tropical:    { label: "Tropical",    dot: "bg-rose-500",    chip: "bg-rose-50 text-rose-800 border-rose-200" },
  subtropical: { label: "Subtropical", dot: "bg-orange-500",  chip: "bg-orange-50 text-orange-800 border-orange-200" },
  temperate:   { label: "Temperate",   dot: "bg-emerald-500", chip: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  continental: { label: "Continental", dot: "bg-sky-500",     chip: "bg-sky-50 text-sky-800 border-sky-200" },
  subarctic:   { label: "Subarctic",   dot: "bg-indigo-500",  chip: "bg-indigo-50 text-indigo-800 border-indigo-200" },
};

export function climateZoneForLat(lat) {
  if (lat == null || Number.isNaN(Number(lat))) return null;
  const a = Math.abs(Number(lat));
  if (a <= 23.5) return "tropical";
  if (a <= 35) return "subtropical";
  if (a <= 50) return "temperate";
  if (a <= 60) return "continental";
  return "subarctic";
}

export function zoneStyle(zone) {
  return ZONE_STYLES[zone] || null;
}

export const CLIMATE_ZONE_STYLES = ZONE_STYLES;
